// besideU logomark + wordmark.
//
// Mark: Maeve's face (`MaeveAvatar`) — PO decision 2026-07-12, superseding
// the earlier gradient-heart placeholder (Brand & Design Guidelines §4's
// "current logo status" note no longer applies). Rendered at a fixed
// `standard` variant with no glow rings regardless of surface — the LOGO is
// one stable identity mark; the CONTEXTUAL Companion avatar elsewhere in the
// app is what legitimately shifts `warm` on employee surfaces. Reusing
// `MaeveAvatar` (not a bespoke SVG) keeps this pixel-identical to every
// other Maeve face in the product, per that component's own "must render
// identically everywhere" rule.
//
// Wordmark: "beside" in Ink (#1A2E35, weight 600) + "U" in Blue Accent
// (#378ADD, weight 700). The lowercase is intentional. On dark backgrounds
// the wordmark flips to white + blue U (`onDark`); `onDark` also forwards to
// `MaeveAvatar` so the mark gets a visible edge stroke — its governed navy/ink
// fills otherwise sit almost exactly on top of the app's own dark-navy
// sidebar background, leaving only the eyes/smile visible with no perceivable
// face boundary.

import { MaeveAvatar } from './MaeveAvatar.tsx';

interface LogoProps {
  /** Render just the mark — useful when space is tight. */
  markOnly?: boolean;
  /** Flip the wordmark to white (for dark navy backgrounds). */
  onDark?: boolean;
  /** Omit the Maeve face mark, wordmark only — e.g. the desktop sidebar rail. */
  hideMark?: boolean;
  className?: string;
}

export function Logo({ markOnly, onDark, hideMark, className }: LogoProps) {
  return (
    <span className={['inline-flex items-center gap-2', className ?? ''].join(' ')}>
      {/* Min mark height is 28px (Brand Guidelines §4); 32px clears it. */}
      {hideMark ? null : (
        <MaeveAvatar
          size={32}
          rings={false}
          variant="standard"
          onDark={onDark ?? false}
          className="shrink-0"
        />
      )}
      {markOnly ? null : (
        <span className="text-base tracking-tight">
          <span className={onDark ? 'font-semibold text-white' : 'font-semibold text-ink'}>
            beside
          </span>
          <span className="font-bold text-blue">U</span>
        </span>
      )}
    </span>
  );
}
